import { Component, inject, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormArray,
  AbstractControl
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from './base.component';

@Component({
  selector: 'lib-base-client',
  template: '',
  standalone: false
})
export class BaseClientComponent extends BaseComponent implements OnInit {
  public clientCode;
  public route = inject(ActivatedRoute);
  constructor() {
    super();
    this.clientCode = this.route.snapshot.paramMap.get('client_code');
  }

  ngOnInit() {}
}
